import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, Phone } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
const RECIPIENT_EMAIL = 'info@888sourcinngltd.co.uk';
export function Contact() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const firstName = data.get('firstName') as string || '';
    const lastName = data.get('lastName') as string || '';
    const company = data.get('company') as string || '';
    const email = data.get('email') as string || '';
    const message = data.get('message') as string || '';
    const subject = `Pre-Qualification Inquiry — ${firstName} ${lastName}`.trim();
    const body = [`Name: ${firstName} ${lastName}`, `Company: ${company}`, `Email: ${email}`, '', 'Message / Core Capabilities:', message].join('\n');
    window.location.href = `mailto:${RECIPIENT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };
  return <section id="contact" className="py-24 relative overflow-hidden" data-id="element-34">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-navy-light/50 -skew-x-12 translate-x-32 -z-10" data-id="element-35" />

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-36">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-37">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-38">
            <SectionHeader eyebrow="Get In Touch" title="Pre-Qualification Inquiry" description="Interested in joining our verified supplier network? Submit your details below to begin the pre-qualification process." data-id="element-39" />

            <div className="space-y-8 mt-12" data-id="element-40">
              <div className="flex items-start gap-4" data-id="element-41">
                <div className="w-10 h-10 bg-navy-card border border-navy-border rounded flex items-center justify-center shrink-0" data-id="element-42">
                  <Mail size={20} className="text-gold" data-id="element-43" />
                </div>
                <div data-id="element-44">
                  <h4 className="text-white font-bold mb-1" data-id="element-45">Email Us</h4>
                  <a href="mailto:info@888sourcinngltd.co.uk" className="text-slate-400 hover:text-gold transition-colors" data-id="element-46">
                    info@888sourcinngltd.co.uk
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-47">
                <div className="w-10 h-10 bg-navy-card border border-navy-border rounded flex items-center justify-center shrink-0" data-id="element-48">
                  <MapPin size={20} className="text-gold" data-id="element-49" />
                </div>
                <div data-id="element-50">
                  <h4 className="text-white font-bold mb-1" data-id="element-51">Headquarters</h4>
                  <p className="text-slate-400" data-id="element-52">
                    London, United Kingdom
                    <br data-id="element-53" />
                    Global Operations
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-54">
            <form className="bg-navy-card p-8 md:p-10 rounded-sm border border-navy-border shadow-2xl" onSubmit={handleSubmit} data-id="element-55">
              <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-56">
                <div data-id="element-57">
                  <label htmlFor="firstName" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-58">
                    First Name
                  </label>
                  <input type="text" id="firstName" name="firstName" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="John" data-id="element-59" />
                </div>
                <div data-id="element-60">
                  <label htmlFor="lastName" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-61">
                    Last Name
                  </label>
                  <input type="text" id="lastName" name="lastName" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Doe" data-id="element-62" />
                </div>
              </div>

              <div className="mb-6" data-id="element-63">
                <label htmlFor="company" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-64">
                  Company Name
                </label>
                <input type="text" id="company" name="company" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Company Ltd." data-id="element-65" />
              </div>

              <div className="mb-6" data-id="element-66">
                <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-67">
                  Business Email
                </label>
                <input type="email" id="email" name="email" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="john@company.com" data-id="element-68" />
              </div>

              <div className="mb-8" data-id="element-69">
                <label htmlFor="message" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-70">
                  Message / Core Capabilities
                </label>
                <textarea id="message" name="message" rows={4} className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors resize-none" placeholder="Briefly describe your manufacturing or distribution capabilities..." data-id="element-71"></textarea>
              </div>

              <button type="submit" className="w-full bg-gold hover:bg-gold-light text-navy font-bold py-4 rounded transition-colors" data-id="element-72">
                Submit Inquiry
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}